import * as result from './lib/generated/possible-types';

export const possibleTypes = result.default.possibleTypes;

export * from './lib/generated/generated';
